<template lang="pug">
.tabela-lote-de-producao.view-container
    h2(v-if='mostrarTitulo' style='font-weight: bold; padding-bottom: 10px;') Listagem de Lote de produção
    el-table(
        :data='dadosTabela',
        stripe,
        style='width: 100%'
    )
        el-table-column(label='Número do Lote de controle', prop='numeroLoteControle', min-width='150px', sortable)
            template(slot-scope='scope')
                p {{ scope.row.numeroLoteControle }}

        el-table-column(label='Data de entrada na usina', prop='dataEntradaUsina', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.dataEntradaUsina }}
        
        el-table-column(label='Número do Lote de produção', prop='numeroLoteProducao', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.numeroLoteProducao }}

        el-table-column(label='Material', prop='material', min-width='150px', sortable)
            template(slot-scope='scope')
                p {{ scope.row.material }}
        
        el-table-column(label='Quantidade do Lote real', prop='quantidadeLoteReal', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.quantidadeLoteReal }}
        
        el-table-column(v-if='mostrarAcoesPadrao' label='Ações', align='left')
            .template.d-flex.justify-content-left(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    BaseButton(link)
                        i.el-icon-more
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-edit',
                            @click.native='editarLoteDeProducao(scope.row)'
                        ) Editar
                        el-dropdown-item(
                            icon='el-icon-delete',
                            @click.native='excluirLoteDeProducao(scope.row)'
                        ) Excluir
    
    .tabela-rodape
        .tabela-rodape--esquerda
            p {{ paginacao.total }} lotes de produção

        .tabela-rodape--pagination
            el-pagination(
                small,
                layout='prev, pager, next',
                :page-size='paginacao.itensPorPagina',
                :current-page.sync='paginacao.pagina',
                :total='paginacao.total',
                @current-change='atualizarPagina(paginacao.pagina - 1)'
            )
    
    ModalEditarLoteDeProducao(
        :mostrar='mostrarModalEditarLoteDeProducao',
        :dados='dados',
        @atualizarDados='atualizarDados',
        @fechar='ChangeModalEditar'
    )

    ModalConfirmarExcluir(
        :mostrar='mostrarModalExcluir',
        :dados='dados',
        @atualizarDados='atualizarDados',
        @fechar='ChangeModalExcluir'
    )

</template>

<script>
import formatters from '@/utils/formatters';
import ModalEditarLoteDeProducao from '@/components/rastreabilidadeRaizen/loteDeProducao/ModalEditarLoteDeProducao.vue';
import ModalConfirmarExcluir from '@/components/rastreabilidadeRaizen/loteDeProducao/ModalConfirmarExcluir.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'TabelaLoteDeProducao',
    emits: ['atualizar-tabela', 'atualizar-pagina'],
    components: {
        ModalEditarLoteDeProducao,
        ModalConfirmarExcluir,
        BaseButton
    },
    props: {
        dadosTabela: {
            type: Array,
            default: () => {}
        },
        mostrarTitulo: {
            type: Boolean,
            default: () => true
        },
        mostrarAcoesPadrao: {
            type: Boolean,
            default: () => true
        },
        paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
        }
    },

    data() {
        return {
            mostrarModalEditarLoteDeProducao: false,
            mostrarModalExcluir: false,
            dados: {}
        };
    },

    methods: {
        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },

        editarLoteDeProducao({
            id,
            numeroLoteControle,
            numeroLoteProducao,
            material,
            quantidadeLoteReal,
            dataEntradaUsina
        }) {
            this.dados = {
                id,
                numeroLoteControle,
                numeroLoteProducao,
                material,
                quantidadeLoteReal,
                dataEntradaUsina
            };

            this.mostrarModalEditarLoteDeProducao = true;
        },

        excluirLoteDeProducao({ id, numeroLoteControle}) {
            this.dados = { id, numeroLoteControle };
            this.mostrarModalExcluir = true;
        },
        
        ChangeModalEditar() {
            this.mostrarModalEditarLoteDeProducao = !this.mostrarModalEditarLoteDeProducao;
        },

        ChangeModalExcluir() {
            this.mostrarModalExcluir = !this.mostrarModalExcluir;
        },

        atualizarDados() {
            this.$emit('atualizar-tabela', this.paginacao.pagina - 1);
        },

        atualizarPagina(pagina) {
            this.$emit('atualizar-pagina', pagina);
        }

    }
};
</script>

<style lang="scss">
.el-table__header-wrapper {
  width: 100%;
  .el-table__header {
    width: 100% !important;
  }
}

// Neede to show the first row in the table
.el-table__body-wrapper {
    width: 100%;
    .el-table__body {
        width: 100% !important;
    }
}

.tabela-selecionar-territorio-monitoramento {
    h3 {
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .el-table {
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;
    }
    .el-table thead {
        color: var(--primary);
        font-weight: 400;
        font-size: 13px;
    }

    .tabela-btn {
        margin-top: 14px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .el-dropdown-link {
        cursor: pointer;
    }

}

.tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 44% 10px 5px;
        margin-top: 8px;
        border-radius: 5px;

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }

        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }

</style>
